import { ApplicationRef, EnvironmentInjector, Injectable, createComponent, inject } from '@angular/core';
import { UiBlockerComponent } from './ui-blocker.component';

@Injectable({ providedIn: 'root' })
export class UiBlockerService {
    private appRef = inject(ApplicationRef);
    private injector = inject(EnvironmentInjector);
    private blockerRef?: any;

    open() {
        if (this.blockerRef) return;

        const compRef = createComponent(UiBlockerComponent, {
            environmentInjector: this.injector
        });

        this.appRef.attachView(compRef.hostView);
        document.body.appendChild(compRef.location.nativeElement);
        this.blockerRef = compRef;
    }

    close() {
        if (!this.blockerRef) return;

        this.appRef.detachView(this.blockerRef.hostView);
        this.blockerRef.destroy();
        this.blockerRef = undefined;
    }
}
